import { usePostPropertyArtMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPropertyArtMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { artFormDefaultValues } from "web_myplann/Portfolio/Forms/ArtForm/artFormDefaults";
import { getArtFormSchema } from "web_myplann/Portfolio/Forms/ArtForm/artFormSchema";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateArtForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPropertyArtMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getArtFormSchema(t),
		defaultValues: artFormDefaultValues,
		mutate,
		successRoute: Routing.Portfolio.PortfolioAddArtSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
